var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFillunlike = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_93086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14.25H7.5V4.5H3C2.80109 4.5 2.61032 4.57902 2.46967 4.71967C2.32902 4.86032 2.25 5.05109 2.25 5.25V13.5C2.25 13.6989 2.32902 13.8897 2.46967 14.0303C2.61032 14.171 2.80109 14.25 3 14.25Z",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.25L11.25 21.75C12.0456 21.75 12.8087 21.4339 13.3713 20.8713C13.9339 20.3087 14.25 19.5456 14.25 18.75V15.5H20.25C20.4628 15.4999 20.6731 15.4546 20.867 15.367C21.0609 15.2794 21.234 15.1516 21.3747 14.992C21.5154 14.8324 21.6206 14.6447 21.6832 14.4413C21.7458 14.238 21.7644 14.0236 21.7378 13.8125L20.6128 5.8125C20.5672 5.45009 20.3908 5.11679 20.1169 4.87514C19.843 4.63349 19.4903 4.5001 19.125 4.5H7.5",
    fill: "#0066CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.25L11.25 21.75C12.0456 21.75 12.8087 21.4339 13.3713 20.8713C13.9339 20.3087 14.25 19.5456 14.25 18.75V15.5H20.25C20.4628 15.4999 20.6731 15.4546 20.867 15.367C21.0609 15.2794 21.234 15.1516 21.3747 14.992C21.5154 14.8324 21.6206 14.6447 21.6832 14.4413C21.7458 14.238 21.7644 14.0236 21.7378 13.8125L20.6128 5.8125C20.5672 5.45009 20.3908 5.11679 20.1169 4.87514C19.843 4.63349 19.4903 4.5001 19.125 4.5H7.5V14.25Z",
    stroke: "#0066CC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_93086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFillunlike);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fillunlike.217aa4f2a6c53832b1831e14acea9300.svg";